// @ts-nocheck
import { Box, Skeleton } from '@mui/material';
import DocumentSheet from './DocumentSheet';
import Logo from '../Logo';

// Loading placeholder for the unified document view — a single A4 sheet with
// a logo header and skeleton text lines, matching the real monolith layout.
export default function DocumentSkeleton() {
  return (
    <Box sx={{ maxWidth: 860, mx: 'auto' }}>
      <DocumentSheet header={<Logo showText sx={{ height: 26 }} />}>
        <Box sx={{ px: 1 }}>
          <Skeleton variant="text" width="45%" height={34} sx={{ mb: 2 }} />
          {Array.from({ length: 7 }).map((_, i) => (
            <Skeleton key={`a${i}`} variant="text" width={i % 3 === 2 ? '70%' : '100%'} />
          ))}
          <Skeleton variant="text" width="35%" height={30} sx={{ mt: 4, mb: 2 }} />
          {Array.from({ length: 5 }).map((_, i) => (
            <Skeleton key={`b${i}`} variant="text" width={i % 2 ? '90%' : '100%'} />
          ))}
        </Box>
      </DocumentSheet>
    </Box>
  );
}
